'use client';

import { useSyncExternalStore } from 'react';
import Script from 'next/script';
import { hasAcceptedCookies, subscribeToCookieConsent } from '@/utils/cookieConsent';

// A Set, so a shared id is configured once rather than counting every page view twice
const GA_IDS = [
  ...new Set(
    [
      process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
      process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
    ].filter(Boolean),
  ),
];
const LINKEDIN_PARTNER_ID = process.env.NEXT_PUBLIC_LINKEDIN_PARTNER_ID;

// Tracking scripts set third-party cookies, so they load only once the cookie banner is accepted;
// one gtag.js serves every GA property instead of a loader per id
export default function ConsentedAnalytics() {
  const accepted = useSyncExternalStore(subscribeToCookieConsent, hasAcceptedCookies, () => false);

  if (!accepted) return null;

  return (
    <>
      {GA_IDS.length > 0 && (
        <>
          <Script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_IDS[0]}`} />
          <Script
            id='google-analytics'
            dangerouslySetInnerHTML={{
              __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                ${GA_IDS.map((id) => `gtag('config', '${id}');`).join('\n')}
              `,
            }}
          />
        </>
      )}

      {LINKEDIN_PARTNER_ID && (
        <>
          <Script
            id='linkedin-insight'
            dangerouslySetInnerHTML={{
              __html: `
                _linkedin_partner_id = "${LINKEDIN_PARTNER_ID}";
                window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
                window._linkedin_data_partner_ids.push(_linkedin_partner_id);
              `,
            }}
          />
          <Script
            id='linkedin-insight-script'
            dangerouslySetInnerHTML={{
              __html: `
                (function(l) {
                  if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
                  window.lintrk.q=[]}
                  var s = document.getElementsByTagName("script")[0];
                  var b = document.createElement("script");
                  b.type = "text/javascript";b.async = true;
                  b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
                  s.parentNode.insertBefore(b, s);
                })(window.lintrk);
              `,
            }}
          />
        </>
      )}
    </>
  );
}
